module.exports = {
  followUs: '关注我们',
  product: {
    title: '产品',
    overview: '概览',
    network: 'ABT 链网',
    node: 'ABT 链节点',
    wallet: 'ABT 钱包',
    blocklets: 'Blocklets',
    sdk: 'Forge SDK',
    ocap: '开放链访问协议'
  },
  learn: {
    title: '学习更多',
    community: '开发者社区',
    workshop: 'DApps Workshop',
    portal: '开发者门户',
    documentation: '技术文档',
    blog: '工程博客',
    learning: '在线课堂',
    solutions: '解决方案'
  },
  aboutUs: {
    title: '关于我们',
    team: '团队',
    jobs: '工作机会',
    leader: '管理团队',
    partners: '合作伙伴',
    token: 'ABT Token',
    news: '新闻',
    roadmap: '路线图'
  },
  contactUs: {
    title: '联系我们',
    support: '支持',
    forPar: '为合作伙伴'
  },
  bottom: {
    ts: '服务条款',
    privacy: '隐私',
    serviceLevel: '服务等级',
    siteMap: '网站地图',
    login: '登录'
  }
};